import { useState } from 'react';
import { Link } from 'react-router';
import { quizData } from '@/data/quizData';
import { BookOpen, Trophy } from 'lucide-react';
import HighScoresModal from '@/react-app/components/HighScoresModal';

export default function Home() {
  const [showHighScores, setShowHighScores] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <div className="bg-gradient-to-br from-blue-900 to-blue-700 p-4 rounded-2xl shadow-lg">
              <BookOpen className="w-12 h-12 text-white" />
            </div>
          </div>
          <h1 className="text-5xl font-bold text-blue-900 mb-3">QuizMaster</h1>
          <p className="text-lg text-gray-600">Test your knowledge with our interactive quizzes</p>
          
          <button
            onClick={() => setShowHighScores(true)}
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-yellow-500 to-yellow-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all"
          >
            <Trophy className="w-5 h-5" />
            View High Scores
          </button>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {quizData.map((quiz) => (
            <Link
              key={quiz.quizID}
              to={`/quiz/${quiz.quizID}`}
              className="group relative overflow-hidden rounded-2xl border-2 border-blue-900 bg-white p-8 transition-all duration-300 hover:shadow-2xl hover:scale-105"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-blue-900/5 to-blue-700/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="relative">
                <h2 className="text-2xl font-bold text-blue-900 mb-3">
                  {quiz.quizName}
                </h2>
                <p className="text-gray-600 mb-4">
                  {quiz.questions.length} questions
                </p>
                <div className="inline-flex items-center text-blue-900 font-semibold group-hover:translate-x-2 transition-transform duration-300">
                  Start Quiz
                  <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <HighScoresModal 
        isOpen={showHighScores} 
        onClose={() => setShowHighScores(false)} 
      />
    </div>
  );
}
